import React, { Component } from 'react';
import { Modal, Button, Table, Tabs } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';


class UpdateLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        activeKey: 'PriceEvaluation',
        pagination:{
            current:1,
            pageSize:10
        },
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { serviceUnitPriceId } = record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryServiceUnitPriceModifyLogList,
            data: { 
                offset: current,
                limit: pageSize,
                serviceUnitPriceId, 
                type: 'SERVICE_UNIT_PRICE',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res; 
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 120,
    }, {
        title: '更新人',
        dataIndex: 'modifyUser',
        key: 'modifyUser',
        width: 120,
        render: (text, record) => {
            const { modifyUserName, modifyUserCode } = record;
            return `${modifyUserName}[${modifyUserCode}]`
        }
    }, {
        title: '更新字段',
        dataIndex: 'modifyFieldName',
        key: 'modifyFieldName',
        width: 120,
    }, {
        title: '更新前',
        dataIndex: 'beforeValue',
        key: 'beforeValue',
        width: 120,
    }, {
        title: '更新后',
        dataIndex: 'afterValue',
        key: 'afterValue',
        width: 120,
    }]

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        },() => {
            this.loadData();
        })
    }

    render() {
        const { visible, loading, data, pagination } = this.state;
        return (
            <Modal
                title="更新日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div>
                        <Table
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                            pagination={pagination}
                            scroll={{ y: 400 }}
                            onChange={this.handleTableChange}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default UpdateLog;


// WEBPACK FOOTER //
// ./src/components/businessOffer/taskUnitPrice/UpdateLog.js